import tmhRequest from '@/config/tmhRequest'

export default {

    searchOilReport: function (data) {
        return tmhRequest({
            url: '/health/tmh/oilreport/searchoilreport',
            method: 'post',
            params: data,
        })
    },

    searchListOilReport: function (data) {
        return tmhRequest({
            url: '/health/tmh/oilreport/searchlistoilreport',
            method: 'post',
            params: data,
        })
    },

    searchResultClassify: function (data) {
        return tmhRequest({
            url: '/health/tmh/oilreport/searchresultclassify',
            method: 'post',
            params: data,
        })
    },

    searchReportResult: function (data) {
        return tmhRequest({
            url: '/health/tmh/oilreport/searchreportresult',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/health/oilreport.js